import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "resume-card"
};
const _hoisted_2 = {
  class: "base-container"
};
const _hoisted_3 = {
  class: "avatar-container"
};
const _hoisted_4 = {
  key: 0,
  class: "info-container"
};
const _hoisted_5 = {
  key: 1,
  class: "info-container"
};
import { ref, computed } from 'vue';
import { ElImage, ElRow, ElSwitch } from "element-plus"; // pre-declaration

export default {
  __name: 'ActorResumeCard',
  props: {
    data: {
      type: Object,
      required: true
    },
    duration: {
      type: Number,
      required: true
    }
  },
  emits: ['submitResume'],

  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit; // refs

    const resumeForm = ref({
      'mvp': false,
      'survival': true,
      'special_experience': 0,
      'skill_point': 0,
      'asset_point': 0
    }); // computed

    const standardExperience = computed(() => {
      const isSurvival = resumeForm.value.survival ?? true;
      const isMVP = resumeForm.value.mvp ?? false;
      let experience = props.duration;
      let ratio = 1;

      if (!isSurvival) {
        ratio -= 0.5;
      }

      if (isMVP) {
        ratio += 0.5;
      }

      return Math.floor(experience * ratio);
    }); // functions

    const confirmForm = () => {
      emits('submitResume', {
        'updates': {
          'id': props.data.id,
          'experience': standardExperience.value,
          ...resumeForm.value
        }
      });
    };

    const getExperienceDesc = () => {
      if (props.data.special_experience === 0) {
        return props.data.experience.toString();
      }

      const symbol = props.data.special_experience > 0 ? ' + ' : ' - ';
      return `${props.data.experience}${symbol}${Math.abs(props.data.special_experience)}`;
    };

    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_input_number = _resolveComponent("el-input-number");

      const _component_el_button = _resolveComponent("el-button");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElRow), {
        style: {
          "align-items": "center"
        }
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElImage), {
          src: __props.data.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("text", null, _toDisplayString(__props.data.nickname), 1)])]), !__props.data.processed ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_form_item, {
          label: "标准经验获取",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(standardExperience.value), 1)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "调整经验",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: resumeForm.value.special_experience,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => resumeForm.value.special_experience = $event),
            min: -50,
            max: 50,
            precision: 0
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "精进点数",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: resumeForm.value.skill_point,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => resumeForm.value.skill_point = $event),
            min: 0,
            max: 100,
            precision: 0
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "资产点数",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input_number, {
            modelValue: resumeForm.value.asset_point,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => resumeForm.value.asset_point = $event),
            min: -100,
            max: 100,
            precision: 1
          }, null, 8, ["modelValue"])]),
          _: 1
        })])) : (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_form_item, {
          label: "经验获取",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(getExperienceDesc()), 1)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "精进点数",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(__props.data.skill_point), 1)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "资产点数",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(__props.data.asset_point), 1)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "是否存活",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(__props.data.survival ? '是' : '否'), 1)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "卓越角色",
          "label-position": "left"
        }, {
          default: _withCtx(() => [_createElementVNode("text", null, _toDisplayString(__props.data.mvp ? '是' : '否'), 1)]),
          _: 1
        })]))]),
        _: 1
      }), !__props.data.processed ? (_openBlock(), _createBlock(_unref(ElRow), {
        key: 0,
        style: {
          "width": "100%",
          "justify-content": "space-between",
          "margin-top": "16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), null, {
          default: _withCtx(() => [_createVNode(_unref(ElSwitch), {
            modelValue: resumeForm.value.mvp,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => resumeForm.value.mvp = $event),
            "active-text": resumeForm.value.mvp ? '卓越' : '',
            "inactive-text": resumeForm.value.mvp ? '' : '通常',
            "inline-prompt": ""
          }, null, 8, ["modelValue", "active-text", "inactive-text"]), _cache[5] || (_cache[5] = _createElementVNode("div", {
            style: {
              "width": "16px"
            }
          }, null, -1)), _createVNode(_unref(ElSwitch), {
            modelValue: resumeForm.value.survival,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => resumeForm.value.survival = $event),
            "active-text": resumeForm.value.survival ? '存活' : '',
            "inactive-text": resumeForm.value.survival ? '' : '死亡',
            "inline-prompt": ""
          }, null, 8, ["modelValue", "active-text", "inactive-text"])]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: confirmForm
        }, {
          default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode(" 提交 ", -1)]))]),
          _: 1
        })]),
        _: 1
      })) : _createCommentVNode("", true)]);
    };
  }

};